import React from 'react';
import { Icon } from 'tmt-ui-kit';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import config from '~/config';

const Container = styled.div`
  position: relative;
  background-color: rgba(0,0,0,.4);
  overflow: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${({ zIndex }) => zIndex || 9000};
  outline: 0;
  position: fixed;
  box-sizing: border-box;
  @media (max-width: 700px) {
    padding: 16px 6px;
  }
  ${props => {
    if (props.isOpen && props.centerVertical) {
      return `
        display: flex;
        align-items: center;
      `;
    }
    if (props.isOpen) {
      return `
        display: block
        padding: 32px 6px;
      `;
    }
    return 'display: none';
  }}
`;

const ModalContent = styled.div`
  z-index: 4;
  border-radius: 5px;
  color: #444;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  margin: 70px auto;
  width: 100%;
  max-width: 500px;
  background: #fff;
  text-align: center;
  @media (max-width: 700px) {
    margin: 60px auto;
  }
`;

const CloseButton = styled.span`
  display: inline-block;
  cursor: pointer;
  ${props => !props.white && `
    background: url('${config.assetPath}/static/icons/close.png') no-repeat 50% 50%;
    background-size: 20px;
  `}
  width: 20px;
  height: 20px;
  margin: ${props => (props.white ? '-16px' : 0)};
  position: absolute;
  right: 6px;
  top: 6px;
  padding: 5px;
  z-index: 100;
`;

const Modal = (props) => {
  return (
    <div>
      {props.isOpen && (
        <Container
          className={props.className}
          isOpen={props.isOpen}
          centerVertical={props.centerVertical}
          onClick={() => props.onClose()}
          style={props.zIndex ? {zIndex: props.zIndex} : null}
          key="modal"
        >
          <ModalContent style={props.style} onClick={(e) => e.stopPropagation()}>
            {!props.noClose && (
              <CloseButton white={props.seeUsInAction} onClick={() => props.onClose()}>
                {props.seeUsInAction && <Icon style={{ color: '#ffffff' }} size="md" name="close"/>}
              </CloseButton>
            )}
            {props.children}
          </ModalContent>
        </Container>
      )}
    </div>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.element,
  onClose: PropTypes.func,
  noClose: PropTypes.bool,
  centerVertical: PropTypes.bool, // eslint-disable-line
  style: PropTypes.object,
  zIndex: PropTypes.number,
  seeUsInAction: PropTypes.bool,
};

Modal.defaultProps = {
  isOpen: false,
  noClose: false,
  centerVertical: false,
  closeStyle: '', // eslint-disable-line
  style: {},
  onClose: () => {},
};

export default Modal;
